import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "loading-state d-flex flex-column align-items-center justify-content-center text-center py-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-3 mb-0 text-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "spinner-border text-primary",
      role: "status"
    }, [
      _createElementVNode("span", { class: "visually-hidden" }, "در حال بارگذاری...")
    ], -1)),
    ($props.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($props.message), 1))
      : _createCommentVNode("", true)
  ]))
}